import { CustomElement } from './element.js';
import { _converse, api } from '@converse/headless/core';
import { html } from 'lit';


export class ConverseBrandByline extends CustomElement {

    render () { // eslint-disable-line class-methods-use-this
        const is_fullscreen = api.settings.get('view_mode') === 'fullscreen';
        return html`
            ${is_fullscreen
                ? html`
                    <p class="brand-subtitle">
                        Une messagerie instantanée qui respecte vos libertés et votre vie privée.
                    </p>
                    <p class="brand-subtitle">
                        Application Web qui s'appuie sur <a target="_blank" rel="nofollow" href="https://conversejs.org">ConverseJS</a>,
                        un client XMPP conçu par <a target="_blank" rel="nofollow" href="https://opkode.com">Opkode</a>
                        <br/>
                        <small>${_converse.VERSION_NAME}</small>
                    </p>
                `
                    : ''}
            `;
    }
}

api.elements.define('converse-brand-byline', ConverseBrandByline);
